import { TTextsOverride } from '@digital-dealer/texts-service';

const textsOverride: TTextsOverride = {
  retail: {
    modules: {
      modelViewer: {
        checkout: {
          bankLoanCalculator: {
            buttonTitle: 'Beregn dit billån',
            title: 'Beregn dit billån',
            monthlyPayment: 'Din månedlige ydelse',
            rules: {
              title: 'Finansiering via Jyske Finans',
              insurancePaymentRequired: 'Kaskoforsikring og betaling via Nets er påkrævet',
              creditApprovalRequired: 'Positiv kreditgodkendelse forudsættes',
              cancellationRight: 'Der er 14 dages fortrydelsesret på lånet',
              reservations: 'Der tages forbehold for trykfejl, afgifts- og prisændringer',
              standAlone: 'Kampagnen kan ikke kombineres med øvrige tilbud og er enkeltstående',
            },
            min: 'min',
            desiredDownPayment: 'Din ønskede udbetaling',
            desiredLoanTerm: 'Din ønskede løbetid på lånet',
            overview: {
              price: 'Pris',
              loanAmount: 'Lånebeløb',
              debtorInterest: 'Debitor rente',
              annualPercentageRate: 'Åop',
              totalCreditConversion: 'Samlede kreditomk.',
              repaidInTotal: 'Tilbagebetalt ialt',
              somethingWentWrong: 'Noget gik galt. Prøv at genindlæse eller gå videre, så ringer vi tilbage.',
            },
          },
        },
      },
    },
  },
};

export default textsOverride;
